import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatError, MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { JsonPipe } from '@angular/common';
import { countries } from '../../../list/countries';
import { CountriesService } from '../../shared/services/countries.service';
import { WeightUnitEnum } from '../../../enum/weight-unit.enum';
import { Weight } from '../../../utils/weight';
import { createCommodityFormGroup } from '../../../constants/commodity-form-group';

@Component({
    selector: 'app-commodity-form',
    imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatHint,
    MatError,
    MatSelect,
    MatSuffix,
    MatOption
],
    templateUrl: './commodity-form.component.html',
    styleUrl: './commodity-form.component.scss'
})
export class CommodityFormComponent {

    @Input()
    public formGroup: FormGroup = createCommodityFormGroup() as FormGroup;

    @Input()
    public currency = 'USD';

    @Input()
    public weightUnit = WeightUnitEnum.KG;

    public countries = countries.map(c => ({ name: c.name, code: c.code }));
    public Weight = Weight;

    get description(): FormControl {
        return this.formGroup.get('description') as FormControl;
    }

    get harmonizedCode(): FormControl {
        return this.formGroup.get('harmonizedCode') as FormControl;
    }

}
